import {
  POLL_MAKE_INVALIDATE,

  POLL_DELETE_REQUEST,
  POLL_DELETE_SUCCESS,
  POLL_DELETE_FAILURE,

  POLL_PUBLISH_REQUEST,
  POLL_PUBLISH_SUCCESS,
  POLL_PUBLISH_FAILURE,

  POLL_PAUSE_REQUEST,
  POLL_PAUSE_SUCCESS,
  POLL_PAUSE_FAILURE,

  POLL_REQUEST,
  POLL_SUCCESS,
  POLL_FAILURE,

  VOTE_REQUEST,
  VOTE_SUCCESS,
  VOTE_FAILURE,

  EDIT_POLL_REQUEST,
  EDIT_POLL_CANCEL,
  EDIT_POLL_REQUEST_SUCCESS,
  EDIT_POLL_REQUEST_FAILURE,

  UPDATE_POLL_REQUEST,
  UPDATE_POLL_SUCCESS,
  UPDATE_POLL_FAILURE,

} from '../../actions/fund/poll';

const defaultState = {
  loading: false,
  didInvalidate: true,
  isEdit: false, // процесс редактирования запроса, форма
};

export default function reducer(state = defaultState, action) {
  switch (action.type) {
    // Данные требуют обновления с сервера
    case POLL_MAKE_INVALIDATE: {
      return {
        ...state,
        didInvalidate: true,
      };
    }

    // Запросы
    case POLL_DELETE_REQUEST:
    case POLL_PUBLISH_REQUEST:
    case POLL_PAUSE_REQUEST:
    case POLL_REQUEST:
    case VOTE_REQUEST:
    case EDIT_POLL_REQUEST:
    case UPDATE_POLL_REQUEST: {
      return {
        ...state,
        loading: true,
      };
    }

    case EDIT_POLL_CANCEL: {
      return {
        ...state,
        isEdit: false,
      };
    }

    // Успешно
    case POLL_PUBLISH_SUCCESS:
    case POLL_PAUSE_SUCCESS:
    case VOTE_SUCCESS: {
      return {
        ...action.payload,
        loading: false,
      };
    }

    case POLL_DELETE_SUCCESS: {
      return { ...defaultState };
    }

    case POLL_SUCCESS: {
      return {
        ...action.payload,
        loading: false,
        didInvalidate: false,
      };
    }

    case EDIT_POLL_REQUEST_SUCCESS: {
      return {
        ...action.payload,
        loading: false,
        isEdit: true,
      };
    }

    case UPDATE_POLL_SUCCESS: {
      return {
        ...action.payload,
        loading: false,
        didInvalidate: false,
        isEdit: false,
      };
    }

    // Неудача
    case POLL_DELETE_FAILURE:
    case POLL_PUBLISH_FAILURE:
    case POLL_PAUSE_FAILURE:
    case VOTE_FAILURE:
    case EDIT_POLL_REQUEST_FAILURE: {
      return {
        ...state,
        loading: false,
      };
    }

    case POLL_FAILURE: {
      return {
        ...state,
        loading: false,
        didInvalidate: false,
      };
    }

    case UPDATE_POLL_FAILURE: {
      return {
        ...state,
        loading: false,
        didInvalidate: false,
      };
    }
    default:
  }

  return state;
}
